import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ScheduleModal = ({
    isScheduleModalOpen,
    setIsScheduleModalOpen,
    waitingListMessage,
    bookingSuccess,
    bookingDetails,
    guestName,
    setGuestName,
    phoneNumber,
    setPhoneNumber,
    numberOfGuests,
    setNumberOfGuests,
    durationMinutes,
    setDurationMinutes,
    scheduleDate,
    setScheduleDate,
    scheduleTime,
    setScheduleTime,
    bookingLoading,
    handleScheduleConfirm
}) => {

    const navigate = useNavigate();

    const [seatingCapacity, setSeatingCapacity] = useState([]);
    const [selectedCapacity, setSelectedCapacity] = useState("");

    // ✅ Fetch Seating Capacity
    useEffect(() => {
        fetchSeatingCapacity();
    }, []);

    const fetchSeatingCapacity = async () => {

        try {

            const token = localStorage.getItem("authToken");

            if (!token) {
                console.error("Auth token not found");
                return;
            }

            const response = await fetch(
                "https://backend.maamaas.com/food/api/seatingdetails/get/seating-capacity/1",
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            console.log("Capacity Data:", data);

            setSeatingCapacity(
                Array.isArray(data)
                    ? data.sort((a, b) => a - b)
                    : []
            );

        } catch (error) {

            console.error("Error fetching seating capacity:", error);

            setSeatingCapacity([]);
        }
    };

    // ✅ Hide Modal
    if (!isScheduleModalOpen) return null;

    return (
        <div className="popup-overlay">

            <div className="popup-box popup-box--lg">

                {/* ✅ TOP CLOSE BUTTON */}
                {/* <button
                    className="popup-top-close-btn"
                    onClick={() => setIsScheduleModalOpen(false)}
                >
                    ✖
                </button> */}

                {/* ✅ WAITING LIST */}
                {waitingListMessage ? (

                    <div className="booking-result">

                        <div className="booking-result-icon">⏳</div>

                        <h2 className="booking-result-title waiting">
                            Added to Waiting List
                        </h2>

                        <div className="booking-result-msg">
                            {waitingListMessage}
                        </div>

                        <p className="booking-result-sub">
                            You'll be notified when a table is available.
                        </p>

                        <button
                            className="popup-close-btn"
                            onClick={() => {
                                setIsScheduleModalOpen(false);

                                navigate('/Myordermain', {
                                    state: { activeTab: 3 }
                                });
                            }}
                        >
                            View Booked Table
                        </button>

                    </div>

                ) : bookingSuccess ? (

                    /* ✅ BOOKING SUCCESS */
                    <div className="booking-result">

                        <div className="booking-result-icon">✅</div>

                        <h2 className="booking-result-title success">
                            Table Booked Successfully!
                        </h2>

                        <div className="booking-details-grid">

                            <div className="booking-detail">
                                <span>Guest</span>
                                <strong>{bookingDetails?.guestName}</strong>
                            </div>

                            <div className="booking-detail">
                                <span>Phone</span>
                                <strong>{bookingDetails?.phoneNumber}</strong>
                            </div>

                            <div className="booking-detail">
                                <span>Guests</span>
                                <strong>{bookingDetails?.numberOfGuests}</strong>
                            </div>

                            <div className="booking-detail">
                                <span>Date</span>
                                <strong>{bookingDetails?.date}</strong>
                            </div>

                            <div className="booking-detail">
                                <span>Time</span>
                                <strong>{bookingDetails?.time}</strong>
                            </div>

                            <div className="booking-detail">
                                <span>Duration</span>
                                <strong>
                                    {bookingDetails?.durationMinutes || "N/A"} hrs
                                </strong>
                            </div>

                        </div>

                        <button
                            className="popup-close-btn"
                            onClick={() => {
                                setIsScheduleModalOpen(false);

                                navigate('/Myordermain', {
                                    state: { activeTab: 3 }
                                });
                            }}
                        >
                            View Booked Table
                        </button>

                    </div>

                ) : (

                    /* ✅ BOOK TABLE FORM */
                    <>
                        <h3 className="popup-title">
                            📅 Book a Table
                        </h3>

                        <div className="schedule-form">

                            {/* ✅ Guest Name */}
                            <input
                                type="text"
                                placeholder="Full Name *"
                                value={guestName}
                                onChange={(e) =>
                                    setGuestName(e.target.value)
                                }
                                className="schedule-input"
                            />

                            {/* ✅ Phone */}
                            <input
                                type="tel"
                                placeholder="Phone Number *"
                                value={phoneNumber}
                                onChange={(e) =>
                                    setPhoneNumber(e.target.value)
                                }
                                className="schedule-input"
                            />

                            {/* ✅ Capacity + Duration */}
                            <div className="schedule-row">

                                {/* Seating Capacity */}
                                <select
                                    value={selectedCapacity}
                                    onChange={(e) => {
                                        setSelectedCapacity(e.target.value);
                                        setNumberOfGuests(e.target.value);
                                    }}
                                    className="schedule-input"
                                >
                                    <option value="">
                                        Select Capacity
                                    </option>

                                    {seatingCapacity.map((item, index) => (
                                        <option
                                            key={index}
                                            value={item}
                                        >
                                            {item} Persons
                                        </option>
                                    ))}
                                </select>

                                {/* Optional Duration */}
                                <input
                                    type="number"
                                    placeholder="Duration (Optional)"
                                    value={durationMinutes}
                                    onChange={(e) =>
                                        setDurationMinutes(
                                            parseInt(e.target.value) || ""
                                        )
                                    }
                                    className="schedule-input"
                                />

                            </div>

                            {/* ✅ Date + Time */}
                            <div className="schedule-row">

                                <input
                                    type="date"
                                    value={scheduleDate}
                                    onChange={(e) =>
                                        setScheduleDate(e.target.value)
                                    }
                                    min={
                                        new Date()
                                            .toISOString()
                                            .split("T")[0]
                                    }
                                    className="schedule-input"
                                />

                                <input
                                    type="time"
                                    value={scheduleTime}
                                    onChange={(e) =>
                                        setScheduleTime(e.target.value)
                                    }
                                    className="schedule-input"
                                />

                            </div>

                            {/* ✅ ACTION BUTTONS */}
                            <div className="schedule-actions">

                                <button
                                    className="schedule-cancel-btn"
                                    onClick={() =>
                                        setIsScheduleModalOpen(false)
                                    }
                                >
                                    Cancel
                                </button>

                                <button
                                    className="schedule-confirm-btn"
                                    onClick={() =>
                                        handleScheduleConfirm()
                                    }
                                    disabled={bookingLoading}
                                >
                                    {bookingLoading
                                        ? 'Booking...'
                                        : 'Confirm Booking'}
                                </button>

                            </div>

                        </div>
                    </>
                )}

            </div>

        </div>
    );
};

export default ScheduleModal;